import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import type {
  IEquipmentAnswers,
  IEquipmentUser,
  IEquipments,
  IEquipmentsState,
  ISetEquipmentAnswer,
  IThunkAPI,
} from '../types';

import { resumeBuilderApis } from '@/api/resume-builder';

export const initialState: IEquipmentsState = {
  equipmentsList: [],
  equipmentAnswers: [],
  equipmentAnswersUser: [],
  isError: false,
  isSuccess: false,
  isFetching: false,
};

export const getEquipmentsList = createAsyncThunk<IEquipments[], number, IThunkAPI>(
  'get/equipments',
  async (application_id: number, thunkAPI) => {
    try {
      const response = await resumeBuilderApis.getEquipmentsList(application_id);

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getEquipmentsAnswerList = createAsyncThunk<IEquipmentAnswers[], undefined, IThunkAPI>(
  'get/equipmentAnswersList',
  async (_, thunkAPI) => {
    try {
      const response = await resumeBuilderApis.getEquipmentsAnswersList();

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);

export const getEquipmentsAnswers = createAsyncThunk<IEquipmentUser[], undefined, IThunkAPI>(
  'get/equimentAnswers',
  async (_, thunkAPI) => {
    try {
      const response = await resumeBuilderApis.getEquipmentAnswers();

      return response.data;
    } catch (e) {
      return thunkAPI.rejectWithValue(e.response.data);
    }
  },
);
export const setEquipmentsAnswers = createAsyncThunk<
  ISetEquipmentAnswer,
  {
    userId: number | undefined;
    userEquipmentId: number;
    equipmentId: number;
    equipmentAnswerId: number;
    lxUser: {
      userId: number | undefined;
    };
    dateCreated: string;
    dateModified: string;
    vocabEquipment: {
      equipmentId: number;
    };
    vocabEquipmentAnswer: {
      equipmentAnswerId: number;
    };
  }[],
  IThunkAPI
>('set/equipmentAnswers', async (payload, thunkAPI) => {
  try {
    const response = await resumeBuilderApis.setEquipmentAnswers(payload);
    return response.data;
  } catch (e) {
    return thunkAPI.rejectWithValue(e.response.data);
  }
});

export const equipmentSlice = createSlice({
  name: 'configSlice',
  initialState,
  reducers: {
    clearState(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isFetching = false;
    },
  },
  extraReducers: builder => {
    builder
      // TODO: getSchedulesList probably to be removed in the future
      .addCase(getEquipmentsList.fulfilled, (state, action) => {
        state.equipmentsList = action.payload;
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getEquipmentsAnswerList.fulfilled, (state, action) => {
        state.equipmentAnswers = action.payload;
        state.isFetching = false;
        state.isSuccess = true;
      })
      .addCase(getEquipmentsAnswers.fulfilled, (state, action) => {
        state.equipmentAnswersUser = action.payload;
        state.isFetching = false;
        state.isSuccess = true;
      });
  },
});

export const { clearState } = equipmentSlice.actions;
export default equipmentSlice.reducer;
